import { Accordion, AccordionDetails, AccordionGroup, AccordionSummary, Alert, Autocomplete, Box, Button, Card, Dropdown, FormControl, FormLabel, IconButton, Input, Menu, MenuButton, Textarea, TextField, Typography } from '@mui/joy'
import React, { useState } from 'react'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { post, Token } from '../../../../../Script/Session';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
import { PlaylistAddCheckCircleRounded } from '@mui/icons-material';
import MenuItem from '@mui/joy/MenuItem';
import MoreVert from '@mui/icons-material/MoreVert';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Warning from '@mui/icons-material/Warning';
import Close from '@mui/icons-material/Close';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { useNavigate } from 'react-router-dom';
function Frageneditor({ data, upd }) {
  const [create, setcreate] = useState(false);
  const [cfrage, setcfrage] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [v, setv] = useState(null);
  const [currentfkath, setcurrentfkath] = useState([]);
  const [cf, setcf] = useState(null);
  const [a, setalert] = useState(false);
  const [q, setq] = useState("");
  const [aaa, setaaa] = useState(null);
  const [del, setdel] = useState(false);
  const [editkath, seteditkath] = useState(false);
  const [kathtoedit, setkathtoedit] = useState(false);
  const [newovervalue, setnewovervalue] = useState(null);


























  const navigate = useNavigate();
  const handleValueChange = (event, newValue) => {
    setv(newValue);
    console.log(newValue);
  };
  const handlenewoverv = (event, newValue) => {
    setnewovervalue(newValue);
    console.log(newValue);
  };
  const handlefkathchange = (event, newValue) => {

    setcurrentfkath(newValue);
    console.log(newValue);
    const fragen = data.fragen.find(f => Object.keys(f)[1] === newValue[0]);
    const testFragen = fragen ? fragen[newValue[0]] : [];
    console.log(testFragen);
    setaaa([testFragen])
    console.log(newValue);
  };
  const handlec = (event, newValue) => {
    setcf(newValue);
    console.log(newValue);
  };
  function editkath_post(newname) {
    let a = 0;
    if (newovervalue.kathegorie != "Keine") {
      a = newovervalue.order + 1;
    }
    let body = {};
    body.token = Token.get();
    body.target = data.id;
    body.action = "update_question_kath";
    body.oldname = kathtoedit;
    body.newname = newname;
    body.lvl = a;
    let response = post(body, "/vergleiche/sub-sparten");
    if (response == "LOGOUT") {
      navigate("/")
    }
    if (response == "OK") {
      setalert(true);
      upd();
      seteditkath(false);
    }

  }
  function addkathegorie(s) {
    let a = 0;
    if (v.name != "Keine") {
      a = v.order + 1;
    }
    let body = {};
    body.token = Token.get();
    body.target = data.id;
    body.action = "add_question_kathegorie";
    body.kathname = s;
    body.lvl = a;
    let response = post(body, "/vergleiche/sub-sparten");
    if (response == "LOGOUT") {
      navigate("/")
    }
    if (response == "OK") {
      setalert(true);

    }
  }
  function delkathegorie(s) {
    let body = {};
    body.token = Token.get();
    body.target = data.id;
    body.action = "remove_question_kathegorie";
    body.kathname = s;
    console.log(body);
   
    let response = post(body, "/vergleiche/sub-sparten");
    upd();
  }
  function delfrage(overkath, quest) {
    let body = {};
    body.token = Token.get();
    body.target = data.id;
    body.action = "remove_question";
    body.overkathegorie = overkath;
    body.question = quest;
    let response = post(body, "/vergleiche/sub-sparten");
    if (response == "LOGOUT") {
      navigate("/")
    }
    if (response == "OK") {
      upd();
      setdel(true);
    }

  }
  const resetAll = () => {
    setvaluefirst("Bis zur Versicherungssumme");
    setpointfirst("5");
    setvaluesecond("Versicherungsschutz eingeschränkt");
    setpointsecond("3");
    setvaluethird("Es besteht kein Versicherungsschutz");
    setpointthird("0");
    setvaluefour("Versicherungsschutz gegen Zuschlag möglich");
    setpointfour("4");
  };
  const [valuefirst, setvaluefirst] = useState("Bis zur Versicherungssumme");
  const [pointfirst, setpointfirst] = useState("5");
  const [valuesecond, setvaluesecond] = useState("Versicherungsschutz eingeschränkt");
  const [pointsecond, setpointsecond] = useState("3");
  const [valuethird, setvaluethird] = useState("Es besteht kein Versicherungsschutz");
  const [pointthird, setpointthird] = useState("0");
  const [valuefour, setvaluefour] = useState("Vericherungsschutz gegen Zuschlag möglich");
  const [pointfour, setpointfour] = useState("4");
  const [currenteditfkath, setcurrenteditfkath] = useState([]);
  const [editaaa, seteditaaa] = useState(null);
  function addfrage() {
    console.log(q);
    if (q == "") {
      return;
    }
    let a = 0;
    console.log(cf);
    if (cf.name != "keine") {
      a = cf.order + 1;
    }
    let body = {};
    body.token = Token.get();
    body.target = data.id;
    body.action = "add_question";
    body.overkathegorie = currentfkath[0];
    body.question = q;
    body.lvl = a;
    body.zerobzh = valuefirst;
    body.zeropoints = Number(pointfirst);
    body.onebzh = valuesecond;
    body.onepoints = Number(pointsecond);
    body.twobzh = valuethird;
    body.twopoints = Number(pointthird);
    body.thridbzh = valuefour;
    body.thirdpoints = Number(pointfour);
    console.log(body);
    let response = post(body, "/vergleiche/sub-sparten");
    if (response == "LOGOUT") {
      navigate("/")
    }
    if (response == "OK") {
      upd();
      setalert(true);
      setcfrage(false);
      resetAll();
    }
  }
  const [editquestion, seteditquestion] = useState(false);
  const [editvaluefirst, seteditvaluefirst] = useState(null);
  const [editpointfirst, seteditpointfirst] = useState(null);
  const [editvaluesecond, seteditvaluesecond] = useState(null);
  const [editpointsecond, seteditpointsecond] = useState(null);
  const [editvaluethird, seteditvaluethird] = useState(null);
  const [editpointthird, seteditpointthird] = useState(null);
  const [editvaluefour, seteditvaluefour] = useState(null);
  const [editpointfour, seteditpointfour] = useState(null);
  const [editq, seteditq] = useState("");
  const [oldq, setoldq] = useState("");
  const [editcf, seteditcf] = useState({ order: 0, name: "keine" });
  const handleeditfkathchange = (event, newValue) => {
    console.log(newValue);
    setcurrenteditfkath(newValue);
    let fragen = data.fragen.find(f => {
      const keys = Object.keys(f).filter(k => k !== "order");
      return keys.length === 1 && keys[0] === newValue;

    });
    let testFragen = fragen ? fragen[newValue] : [];
    if (!fragen) {
      fragen = data.fragen.find(f => Object.keys(f)[1] === newValue[0]);
      testFragen = fragen ? fragen[newValue[0]] : [];
    }
    console.log(testFragen);
    seteditaaa([testFragen]);

  };
  const edithandlec = (event, newValue) => {
    seteditcf(newValue);
    console.log(newValue);
  };
  function editfrage(item) {
    setoldq(item.name);
    seteditq(item.name);
    seteditvaluefirst(item.bewertung[0].bzh);
    seteditpointfirst(Number(item.bewertung[0].point));
    console.log("DEBUG: " + Number(item.bewertung[0].point))
    seteditvaluesecond(item.bewertung[1].bzh);
    seteditpointsecond(Number(item.bewertung[1].point));
    seteditvaluethird(item.bewertung[2].bzh);
    seteditpointthird(Number(item.bewertung[2].point));
    seteditvaluefour(item.bewertung[3].bzh);
    seteditpointfour(Number(item.bewertung[3].point));
    if (item.order === 0) {
      console.log("Done")
      seteditcf({ order: 0, name: "keine" });
    } else {
      const fragen = data.fragen.find(f => {
        const keys = Object.keys(f).filter(k => k !== "order");
        return keys.length === 1 && keys[0] === currenteditfkath;
      });
      if (fragen) {

        const fragenArray = fragen[currenteditfkath]; // The actual array
        const previousItem = fragenArray.find(s => s.order === item.order - 1);
        console.log("p")
        seteditcf(previousItem);
        console.log(editcf)


      }
    }
    seteditquestion(true);
    console.log("open");
  }
  function saveeditfrage() {
    console.log(oldq);

    if (editq == "") {
      return;
    }
    let a = 0;
    console.log(editcf);
    if (editcf) {
      if (editcf.name != "keine") {
        a = editcf.order + 1;
      }
    }

    let body = {};
    body.token = Token.get();
    body.target = data.id;
    body.action = "edit_question";
    body.overkathegorie = currenteditfkath;
    body.question = editq;
    body.lvl = a;
    body.zerobzh = editvaluefirst;
    body.zeropoints = Number(editpointfirst);
    body.onebzh = editvaluesecond;
    body.onepoints = Number(editpointsecond);
    body.twobzh = editvaluethird;
    body.twopoints = Number(editpointthird);
    body.thridbzh = editvaluefour;
    body.thirdpoints = Number(editpointfour);
    body.oldquestion = oldq;

    console.log(body);
    let response = post(body, "/vergleiche/sub-sparten");
    if (response == "LOGOUT") {
      navigate("/")
    }
    if (response == "OK") {
      upd();
      setalert(true);
      setcfrage(false);
      resetAll();
      seteditquestion(false);
    }

  }
  return (
    <>
      <Card variant='soft' sx={{ display: "flex", justifyContent: "space-between", flexDirection: "row", mb: 4 }}>
        <Box>
          <Typography level="title-md">Fragenkathegorie Erstellen</Typography>
          <Typography>Erstelle eine neu fragekathegorie um die übersicht zu bewahren</Typography>
        </Box>
        <Button sx={{ height: "5%", mt: 1 }} startDecorator={<AddBoxOutlinedIcon />} onClick={
          () => setcreate(!create)
        }>Erstellen</Button>
      </Card>

      {
        a && (
          <Alert
            sx={{ mb: 5 }}
            variant="soft"
            color="success"
            startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
            endDecorator={
              <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                Schliesen
              </Button>
            }
          >
            Ihre änderungen wurden Erfolgreich gespeichert.
          </Alert>
        )
      }
      {
        del && (
          <Alert
            color="warning"
            variant="soft"
            startDecorator={<Warning />}
            endDecorator={
              <IconButton size="sm" variant="plain" color="warning" onClick={() => setdel(false)}>
                <Close />
              </IconButton>
            }
            sx={{
              backgroundColor: '#FFF3CD',
              color: '#856404',
              border: '1px solid #ffeeba',
              borderRadius: '8px',
              fontWeight: 'bold',
            }}
          >
            Deine Frage wurde gelöscht
          </Alert>
        )

      }
      {
        editquestion && (
          <Card sx={{ mb: 2, mt: 2, width: "98%" }} variant='soft'>
            <Typography level="title-md">Frage Erstellen</Typography>
            <Typography>Bitte geben sie die Fragenkathegorie an</Typography>
            <Autocomplete sx={{ width: "30%" }}
              onChange={handleeditfkathchange}
              value={currenteditfkath}
              options={
                data.fragen.map(item => { return Object.keys(item).filter(k => k !== "order"); })
              }
              getOptionLabel={(option) => option}
            ></Autocomplete>
            <Typography>Bitte geben sie ihre frage ein</Typography>
            <FormControl sx={{ width: "30%" }}>
              <Textarea sx={{ minHeight: "40px" }} value={editq} onChange={(event) => seteditq(event.target.value)} id='aksdlk9292349023482341ß2111129i3' minRows={1} />
            </FormControl>
            <Typography>Bitte geben sie die Übergeordnete Frage an</Typography>
            <Autocomplete sx={{ width: "30%" }}
              onChange={edithandlec}
              value={editcf}
              options={
                editaaa.length > 0
                  ? [{ order: 0, name: "keine" }, ...editaaa.flat()].filter(item => item.name != oldq)
                  : [{ order: 0, name: "keine" }]
              }
              getOptionLabel={(option) => option.name}
            ></Autocomplete>




            <Card
              variant="soft"
              color="success"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <CheckCircleOutlineOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={editvaluefirst} sx={{ minHeight: "30px" }} onChange={(event) => { seteditvaluefirst(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={editpointfirst} onChange={(event) => { seteditpointfirst(event.target.value); console.log(event.target.value) }} type='Number' />
              </Box>
            </Card>







            <Card
              variant="soft"
              color="warning"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <RadioButtonCheckedOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={editvaluesecond} sx={{ minHeight: "30px" }} onChange={(event) => { seteditvaluesecond(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={editpointsecond} onChange={(event) => { seteditpointsecond(event.target.value) }} type='Number' />
              </Box>
            </Card>








            <Card
              variant="soft"

              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,
                bgcolor: "#ffebee",                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <NotInterestedOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={editvaluethird} sx={{ minHeight: "30px" }} onChange={(event) => { seteditvaluethird(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={editpointthird} onChange={(event) => { seteditpointthird(event.target.value) }} type='Number' />
              </Box>
            </Card>













            <Card
              variant="soft"
              color="success"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <MonetizationOnOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={editvaluefour} sx={{ minHeight: "30px" }} onChange={(event) => { seteditvaluefour(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={editpointfour} onChange={(event) => { seteditpointfour(event.target.value) }} type='Number' />
              </Box>
            </Card>















            <Button sx={{ height: "5%", mt: 1, width: "10%" }}
              startDecorator={<SaveOutlinedIcon />}
              onClick={() => {

                saveeditfrage();


              }}
            >Speichern</Button>
          </Card>
        )
      }








      {
        create && (
          <Card variant='soft' sx={{ display: "flex", justifyContent: "space-between", flexDirection: "row", mb: 5 }}>
            <Box>
              <Typography level="title-md" sx={{ mb: 1 }}>Fragekathegorie Anlegen</Typography>
              <Typography sx={{ mb: 1 }}>Bitte gib den Namen der kathegorie an</Typography>
              <Input sx={{ mb: 1 }} id='3284238408293412121ßßßß129399142' placeholder='Name' />
              <Typography sx={{ mb: 1 }}>Übergeordnete Kathegorie</Typography>
              <Autocomplete
                onChange={handleValueChange}
                options={
                  Array.isArray(data.fragen) && data.fragen.length > 0
                    ? [
                      ...data.fragen.map(item => {
                        const kathegorie = Object.keys(item).find(key => key !== "order");
                        return {
                          kathegorie,
                          order: item.order
                        };
                      }),
                      { kathegorie: "Keine", order: 0 }
                    ]
                    : [{ kathegorie: "Keine", order: 0 }]
                }
                getOptionLabel={(option) => option.kathegorie}
              >Kathegorie</Autocomplete>
            </Box>
            <Button sx={{ height: "5%", mt: 1 }}
              startDecorator={<SaveOutlinedIcon />}
              onClick={() => {
                let i = document.getElementById("3284238408293412121ßßßß129399142").value;
                if (i && i != "" && v != null) {
                  addkathegorie(i);
                  upd();
                  setcreate(false);
                }

              }}>Speichern</Button>
          </Card>
        )
      }
      {
        editkath && (
          <Card sx={{ mb: 2, mt: 2, width: "98%" }} variant='soft'>
            <Typography level="title-md">Fragenkathegorie {kathtoedit} Bearbeiten</Typography>
            <Typography>Neuer Kathegoriename</Typography>
            <Input id='1928340283450199904890ß195358aaaaa95ß915ß95ß9185ß95' sx={{ width: "30%" }} placeholder={kathtoedit} />
            <Typography>Übergeordnete Kathegorie</Typography>
            <Autocomplete
              onChange={handlenewoverv}
              options={
                Array.isArray(data.fragen) && data.fragen.length > 0
                  ? [
                    ...data.fragen
                      .map(item => {
                        const keys = Object.keys(item).filter(key => key !== "order" && key !== kathtoedit);
                        if (keys.length === 0) return null; // kein gültiger Key, also überspringen
                        return {
                          kathegorie: keys[0],
                          order: item.order
                        };
                      })
                      .filter(Boolean), // entfernt null-Einträge
                    { kathegorie: "Keine", order: 0 }
                  ]
                  : [{ kathegorie: "Keine", order: 0 }]
              }
              getOptionLabel={(option) => option.kathegorie}
              sx={{ width: "30%" }} />
            <Button sx={{ height: "5%", mt: 1, width: "10%" }}
              startDecorator={<SaveOutlinedIcon />}
              onClick={() => {
                let val = document.getElementById("1928340283450199904890ß195358aaaaa95ß915ß95ß9185ß95").value;
                if (newovervalue != null) {
                  editkath_post(val ? val : kathtoedit);
                }
              }}
            >Speichern</Button>

          </Card>






        )
      }
      {
        cfrage && (
          <Card sx={{ mb: 2, mt: 2, width: "98%" }} variant='soft'>
            <Typography level="title-md">Frage Erstellen</Typography>
            <Typography>Bitte geben sie die Fragenkathegorie an</Typography>
            <Autocomplete sx={{ width: "30%" }}
              onChange={handlefkathchange}
              options={
                data.fragen.map(item => { return Object.keys(item).filter(k => k !== "order"); })
              }
              getOptionLabel={(option) => option}
            ></Autocomplete>
            <Typography>Bitte geben sie ihre frage ein</Typography>
            <FormControl sx={{ width: "30%" }}>
              <Textarea sx={{ minHeight: "40px" }} onChange={(event) => setq(event.target.value)} id='aksdlk9292349023482341ß2111129i3' minRows={1} />
            </FormControl>
            <Typography>Bitte geben sie die Übergeordnete Frage an</Typography>
            <Autocomplete sx={{ width: "30%" }}
              onChange={handlec}
              options={
                aaa.length > 0
                  ? [{ order: 0, name: "keine" }, ...aaa.flat()]
                  : [{ order: 0, name: "keine" }]
              }
              getOptionLabel={(option) => option.name}
            ></Autocomplete>




            <Card
              variant="soft"
              color="success"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <CheckCircleOutlineOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={valuefirst} sx={{ minHeight: "30px" }} onChange={(event) => { setvaluefirst(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={pointfirst} onChange={(event) => { setpointfirst(event.target.value) }} type='Number' />
              </Box>
            </Card>







            <Card
              variant="soft"
              color="warning"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <RadioButtonCheckedOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={valuesecond} sx={{ minHeight: "30px" }} onChange={(event) => { setvaluesecond(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={pointsecond} onChange={(event) => { setpointsecond(event.target.value) }} type='Number' />
              </Box>
            </Card>








            <Card
              variant="soft"

              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,
                bgcolor: "#ffebee",                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <NotInterestedOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={valuethird} sx={{ minHeight: "30px" }} onChange={(event) => { setvaluethird(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={pointthird} onChange={(event) => { setpointthird(event.target.value) }} type='Number' />
              </Box>
            </Card>













            <Card
              variant="soft"
              color="success"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // zentriert Inhalt vertikal
                gap: 2,                // Abstand zwischen Icon und Text
                p: 2,
                mb: 5,                  // Padding innen
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  bgcolor: "success.main",
                  borderRadius: "50%",
                  flexShrink: 0
                }}
              >
                <MonetizationOnOutlinedIcon />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", }}>
                <Typography level="title-md">Beschreibung bearbeiten</Typography>
                <FormControl sx={{ width: "360px" }}>
                  <Textarea value={valuefour} sx={{ minHeight: "30px" }} onChange={(event) => { setvaluefour(event.target.value) }} minRows={1} />
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", ml: 5 }}>
                <Typography level="title-md">Punktzahl bearbeiten</Typography>
                <Input value={pointfour} onChange={(event) => { setpointfour(event.target.value) }} type='Number' />
              </Box>
            </Card>















            <Button sx={{ height: "5%", mt: 1, width: "10%" }}
              startDecorator={<SaveOutlinedIcon />}
              onClick={() => {

                addfrage();


              }}
            >Speichern</Button>
          </Card>
        )
      }
      <AccordionGroup sx={{ p: 0, mb: 5 }}>
        {data.fragen &&
          data.fragen
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((item) => {
              const keys = Object.keys(item).filter(k => k !== "order");
              const name = keys[0] || "Unbenannt";
              return (
                <Card variant='soft' sx={{ p: 0, mb: 1 }}>
                  <Accordion
                    key={item.order}
                    sx={{ p: 0 }}
                  >
                    <AccordionSummary
                      sx={{
                        width: "100%",
                        padding: "1rem",
                        pl: 3,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: -1,
                        p: 1,
                      }}

                    >
                      <Box sx={{ width: "95%", display: "flex", justifyContent: "space-between" }}>
                        <Typography >{name}</Typography>
                      </Box>
                      <Dropdown>
                        <MenuButton
                          slots={{ root: IconButton }}
                          slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                        >
                          <MoreVert />
                        </MenuButton>
                        <Menu>
                          <MenuItem onClick={() => { seteditkath(true); setkathtoedit(name) }}>Kathegorie Bearbeiten</MenuItem>
                          <MenuItem onClick={() => { setcfrage(true); setaaa(item[name]); console.log(item[name]) }}>Frage Hinzufügen</MenuItem>
                          <MenuItem sx={{ color: "red" }} onClick={()=> delkathegorie(name)}>Kathegorie löschen</MenuItem>
                        </Menu>
                      </Dropdown>
                    </AccordionSummary>
                    <AccordionDetails sx={{ width: "100%", minHeight: "10px" }}>
                      <Box sx={{ p: 2 }}
                        onClick={() => {
                          handleeditfkathchange(null, name);
                          console.log("set");
                        }}>
                        {item[name].slice()
                          .sort((a, b) => a.order - b.order).map(item => {
                            return <Box sx={{
                              display: "flex", flexDirection: "row", justifyContent: "space-between", '&:hover': {
                                backgroundColor: '#f0f0f0', // or any color you prefer
                                cursor: 'pointer',          // optional, for interactivity
                              },
                            }}>
                              <Typography level='subtitle1' key={item.order}>{item.name}</Typography>
                              <Box>
                                <IconButton sx={{ color: "gray", mr: 3.2 }} aria-label="Bearbeiten" size="small" onClick={() => { editfrage(item); }}><EditOutlinedIcon /></IconButton>
                                <IconButton sx={{ color: "red", mr: 3.2 }} aria-label="Löschen" size="small" onClick={() => delfrage(name, item.name)}><DeleteOutlineOutlinedIcon /></IconButton>

                              </Box>
                            </Box>;
                          })}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </Card>
              );
            })}
      </AccordionGroup>

    </>
  )
}

export default Frageneditor
